import axios from "axios";
import { getToken } from "~/redux/user/tokens";

export const fetchSearchResults = () =>
  new Promise((resolve, reject) => {
    const url = window.localStorage.getItem("searchFilterURL");
    if (url) {
      getToken(token => {
        axios
          .get(url, {
            headers: {
              "x-api-key": window.settings.baseAPIKey,
              Authorization: token
            }
          })
          .then(({ data }) => data.filter(i => !i.gist.isLiveStream))
          .then((res) => resolve(res))
          .catch(reject);
      });
    } else {
      resolve(null);
    }
  });
